module.exports = __webpack_public_path__ + "../../dist/Messanger/img/no_token.683e1ea4.png";